import cn from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { BatteryChargeIcon, ChambersFillnessIcon, NotificationIcon } from '@/Components/Icons';
import { Icon } from '@/Components/UI';
import { LinkHelper } from '@/Services';
import { DeviceChambersState } from '@/Services/api/methods/v2/Notifications/response';

import { DeviceCardProps } from './DeviceCard.types';
import S from './styles.module.scss';

export const DeviceCard: FC<DeviceCardProps> = ({ device, stationId }) => {
    return (
        <Link
            to={LinkHelper.iRomaScentsNotificationsDeviceId(stationId, device.id)}
            className={cn(S.device, { [S['device-disabled']]: !device.is_powered_on })}
            key={`device_${device.id}`}
        >
            <div className={S.device_information}>
                <div className={S.information_wrapper}>
                    <div className={S.information_item}>
                        <span className={S.information_title}>Device ID</span>
                        <span className={S.information_name}>{device.identifier?.replace(/:/g, '').slice(-8)}</span>
                    </div>
                    {device.license.representation && (
                        <div className={S.information_item}>
                            <span className={S.information_title}>License</span>
                            <span className={S.information_name}>{device.license.representation}</span>
                        </div>
                    )}
                </div>
                <div className={cn({ [S.unread]: device.has_unread_notifications })}>
                    <NotificationIcon />
                </div>
            </div>
            <div className={S.device_statuses}>
                <ChambersFillnessIcon
                    color={device.chambers_fullness.color}
                    className={cn({ [S.flicker]: device.chambers_fullness.state === DeviceChambersState.FLICKERING })}
                />
                <div className={S.divider} />
                <BatteryChargeIcon color={device.battery_level.color} />
                {device.is_firmware_update_available && (
                    <>
                        <div className={S.divider} />
                        <Icon name="warning" size={20} />
                    </>
                )}
            </div>
        </Link>
    );
};
